import React from 'react';

import ErrorComponent from '../components/atoms/error/error';
import { labelType } from '../labels/labels';
import t from '../labels/labelling-utils';

// FIXME: Replace all local definitions inside components (e.g. templates/card-ranking/card-ranking.tsx)
export const getErrorComponent = (message: labelType = 'unavailable.data') => (
  <ErrorComponent>{t(message)}</ErrorComponent>
);
